import React from 'react';

import { useShiftNoteCapture } from 'shiftNotes/helpers/ShiftNoteCaptureProvider';

import NoteCaptureProcessing from './NoteCaptureProcessing';

export default function NoteCaptureInlineProcessing(): JSX.Element | null {
  const { pendingUploads, retryUpload, dismissUpload } = useShiftNoteCapture();
  if (pendingUploads.length === 0) return null;
  const newestFirst = [...pendingUploads].reverse();
  return (
    <>
      {newestFirst.map((upload) => (
        <NoteCaptureProcessing
          key={upload.id}
          inline
          upload={upload}
          onRetry={retryUpload}
          onDismiss={dismissUpload}
        />
      ))}
    </>
  );
}
